<template>
  <div class="sample-graph">
    <div class="case">
      <div class="case-title">
        <img class="case-title_icon" src="@/assets/images/icon_hsfl_.png" alt />
        <div class="case-title_max">回收分类</div>
      </div>
      <div class="class_type">
        <el-radio-group v-model="machineTypeId" v-if="classList.length != 0">
          <el-radio-button v-for="item in classList" :key="item.id" :label="item.id">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <span v-else class="tip">暂无低端机分类数据，请先添加标记</span>
      </div>
      <GlobalChunk icon="image" title="示例图设置">
        <div class="flex flex-jb mb-20">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="$refs['addSampleImageDia'].open()">添加示例图
          </el-button>
        </div>
        <GlobalTable :maxHeight="600" class="sample-image" ref="GlobalTable" v-loading="tableLoading"
          :columns="tableColumns" :data="tableData" :isPagination="false">
          <el-table-column label="示例图" slot="sampleImage" align="center">
            <template slot-scope="{ row }">
              <img :src="row.sampleImage" style="width: 70px;height:70px" alt="" @click="seeSampleImage(row)" />
            </template>
          </el-table-column>
          <el-table-column label="可以开机上架" slot="startingUpStow" align="center">
            <template slot-scope="{ row }">
              <el-switch v-model="row.startingUpStow" active-text="开" inactive-text="关" inactive-color="#b6b9d0"
                @change="(e) => switchChange(e, row, '01')">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="不能开机上架" slot="noStartingUpStow" align="center">
            <template slot-scope="{ row }">
              <el-switch v-model="row.noStartingUpStow" active-text="开" inactive-text="关" inactive-color="#b6b9d0"
                @change="(e) => switchChange(e, row, '02')">
              </el-switch>
            </template>
          </el-table-column>
          <!-- <el-table-column label="不能开机-整机废板" slot="isWasteBoard" align="center">
            <template slot-scope="{ row }">
              <el-switch v-model="row.isWasteBoard" active-text="开" inactive-text="关" inactive-color="#b6b9d0"
                @change="(e) => switchChange(e, row, '05')">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column label="默认排序" slot="sort" align="center">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.sort" @change="handleSortChange(row)" size="mini" :min="1"
                label="排序"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="设置机型" slot="machineConfig" align="center">
            <template slot-scope="{ row }">
              <p v-if="row.machineConfig == '00'">全部机型</p>
              <p v-else class="link primary" @click="modelConfigNext(row)">指定{{ row.machineNum }}个机型</p>
              <p class="link danger" @click="$refs['modelConfigDia'].open(row)">修改配置</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" slot="operation" align="center">
            <template slot-scope="{ row }">
                <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
                <el-button size="mini" type="primary" @click="$refs['addSampleImageDia'].open(row)">编辑</el-button>
            </template>
          </el-table-column>
        </GlobalTable>
      </GlobalChunk>
    </div>
    <el-dialog :title="putDialogTitle" :visible.sync="putDialogShow" :close-on-click-modal="false" width="550px"
      @closed="putDialogClosed">
      <div class="cance-tip">
        <div class="tip-sure">是否确认{{ putDialogTitle == '上架提示' ? '上架' : '下架' }}该示例图 ？</div>
      </div>
      <div class="command">
        <div style="width: 88px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/g,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="putDialogShow = false">取消</el-button>
        <el-button type="primary" :loading="putBtnLoading" @click.native="putDialogSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="删除提示" :visible.sync="delDiaShow" :close-on-click-modal="false" width="550px"
      @closed="deletedId = ''">
      <div class="cance-tip">
        <p>删除示例图，将影响门店端显示</p>
        <div class="tip-sure">是否确认删除该示例图 ？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="delDiaShow = false">取消</el-button>
        <el-button type="primary" :loading="delBtnLoading" @click.native="delDialogSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="showViewerClose" :url-list="imgList" />
    <AddSampleImageDia ref="addSampleImageDia" :machineTypeId="machineTypeId"
      @confirm="getListByMachineType" />
    <ModelConfigDia ref="modelConfigDia" @confirm="modelConfigNext" />
    <ModelSelectDia ref="modelSelectDia" :ids="machineIdList" :machineTypeId="machineTypeId"
      @confirm="modelSelectConfirm" />
  </div>
</template>

<script>
import _api from "@/utils/request";
import { http } from "@/utils/request/lowPhonemanagement";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import AddSampleImageDia from "./dialog/AddSampleImageDia.vue";
import ModelConfigDia from "./dialog/ModelConfigDia.vue";
import ModelSelectDia from "./dialog/ModelSelectDia.vue";
export default {
    components: { ElImageViewer,AddSampleImageDia,ModelConfigDia,ModelSelectDia },
    data() {
    return {
      classList: [],
      machineTypeId: "",
      tableLoading: false,
      tableData: [],
      tableColumns: [
        { label: "示例图名称", prop: "imageName" },
        { slotName: "sampleImage" },
        { slotName: "startingUpStow" },
        { slotName: "noStartingUpStow" },
        // { slotName: "isWasteBoard" },//整机费版
        { slotName: "machineConfig" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "sort" },
        { slotName: "operation" },
      ],
      showViewer: false,
      imgList: [],
      // 开关操作弹框
      putDialogTitle: '',
      putDialogShow: false,
      saveType: '',
      command: '',
      rowId: '',
      putBtnLoading: false,
      machineIdList: [],
      // 删除提示弹框
      delDiaShow: false,
      deletedId: "",
      delBtnLoading: false,
    };
  },
  created() {
    this.getClassList();
  },
  watch: {
    machineTypeId() {
      this.getListByMachineType();
    }
  },
  methods: {
    // 获取分类集合
    getClassList() {
      http.selectLowList().then((res) => {
        this.classList = res.data ? res.data : [];
        this.machineTypeId = res.data && res.data.length?res.data[0].id:'';
      });
    },
    // 获取示例图列表
    getListByMachineType() {
      let params = {
        machineTypeId: this.machineTypeId,
        imageType: '02',
      };
      this.tableLoading = true;
      _api.sampleImage(params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.sampleImages;
          this.tableLoading = false;
        }
      });
    },
    modelConfigNext({ id, machineConfig }) {
      this.modelConfigFormData = { id, machineConfig }
      if (machineConfig == '00') {
        this.modelSelectConfirm()
      } else {
        _api.getMachineConfig({ id }).then(res => {
          this.machineIdList = res.data.machineIdList
          this.$nextTick(() => {
            this.$refs['modelSelectDia'].open()
          })
        })
      }
    },
    modelSelectConfirm(machineIdList) {
      _api.saveMachineConfig({
        ...this.modelConfigFormData,
        isIos: this.position == '02' ? '01' : '02',
        machineIdList
      }).then(res => {
        this.$message.success("修改成功");
        this.getListByMachineType()
        this.$refs['modelSelectDia'].close()
      })
    },
    // 查看示例图大图
    seeSampleImage(row) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(row.sampleImage);
    },
    // 上/下架弹框关闭回调
    putDialogClosed() {
      this.command = ""
      this.getListByMachineType();
    },
    // 设置示例图显示配置
    switchChange(e, row, type) {
      this.saveType = type;
      this.putDialogTitle = e ? "上架提示" : "下架提示";
      this.rowId = row.id;
      if (type == "01") {
        this.startingUpStow = e;
      }
      if (type == "02") {
        this.noStartingUpStow = e;
      }
      if (type == "05") {
        this.isWasteBoard = e;
      }
      this.putDialogShow = true;
      this.putBtnLoading = false;
    },
    // 上/下架弹框确定
    putDialogSubmit() {
      let params = {
        imageType: '02',
        saveType: this.saveType,
        command: this.command,
        id: this.rowId,
      };
      if (this.saveType == "01") {
        params.startingUpStow = this.startingUpStow;
      }
      if (this.saveType == "02") {
        params.noStartingUpStow = this.noStartingUpStow;
      }
      if (this.saveType == "05") {
        params.isWasteBoard = this.isWasteBoard;
      }
      this.putBtnLoading = true;
      _api
        .setImageShowConfig(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success(res.msg || "操作成功");
            this.putDialogShow = false;
          }
        }).finally(() => {
          this.putBtnLoading = false
        })
    },
    // 排序
    handleSortChange(row) {
      console.log(row);
      const params = {
        id: row.id,
        sort: row.sort,
      };
      _api.imageSort(params).then((res) => {
        if (res.code === 1) {
            this.getListByMachineType();
            this.$message.success(res.msg);
        }
      });
    },
    showViewerClose() {
      this.showViewer = false;
    },
    //删除
    handleDelete(val) {
      console.log(val);
      this.delDiaShow = true;
      this.deletedId = val.id;
    },
    delDialogSubmit() {
      this.delBtnLoading = true
      _api.imageDelete({ id: this.deletedId }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg || "删除成功");
          this.getListByMachineType();
          this.delDiaShow = false;
        }
      }).finally(()=>{
        this.delBtnLoading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.sample-graph{
    
  /deep/ .global-chunk_header {
    border: 0;
  }
  /deep/.global-chunk_content{
    padding-top: 0 !important;
  }
  .case {
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    width: 100%;
    padding: 14px 0;

    .class_type {
      padding: 20px;

      .tip {
        font-size: 14px;
        color: #666666;
      }

      /deep/ .el-radio-group {
        .el-radio-button {
          margin-right: 20px;

          .el-radio-button__inner {
            border-radius: 4px;
            border: 1px solid #0981ff;
          }
        }
      }
    }

    .case-title {
      padding: 0 20px;
      display: flex;

      .case-title_icon {
        width: 20px;
        height: 20px;
        margin-right: 3px;
        margin-top: 10px;
      }

      .case-title_max {
        height: 17px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 41px;
      }
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb{
    display: flex;
    justify-content: space-between;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  /deep/ .el-input-group__prepend {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .cance-tip {
    color: #ff8080;
    font-size: 14px;
    margin-bottom: 20px;

    .tip-sure {
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
        text-align: center;
    }
  }
  .link {
    text-decoration: underline;
    cursor: pointer;

    &.primary {
      color: #0981ff;
    }

    &.danger {
      color: #ff687b;
    }
  }

  .nowrap-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .sample-image {
    /deep/.el-switch__label * {
      line-height: 1;
      font-size: 12px;
      display: inline-block;
    }

    /deep/.el-switch__label {
      position: absolute;
      display: none;
      color: #fff !important;
      font-size: 12px !important;
    }

    /*打开时文字位置设置*/
    /deep/.el-switch__label--right {
      z-index: 1;
      right: 4px;
    }

    /*关闭时文字位置设置*/
    /deep/.el-switch__label--left {
      z-index: 1;
      left: 4px;
    }

    /*显示文字*/
    /deep/.el-switch__label.is-active {
      display: block;
    }

    /*开关宽度*/
    /deep/.el-switch .el-switch__core,
    /deep/.el-switch .el-switch__label {
      width: 50px !important;
    }
  }
}

</style>